module.exports = __webpack_public_path__ + "img/md-notifications-outline.8c92d157.svg";